import { message } from 'antd';
import axios from 'axios';

// Action Types
export const NEWSLETTER_CREATE_REQUEST = 'NEWSLETTER_CREATE_REQUEST';
export const NEWSLETTER_CREATE_SUCCESS = 'NEWSLETTER_CREATE_SUCCESS';
export const NEWSLETTER_CREATE_FAIL = 'NEWSLETTER_CREATE_FAIL';

export const NEWSLETTER_LIST_REQUEST = 'NEWSLETTER_LIST_REQUEST';
export const NEWSLETTER_LIST_SUCCESS = 'NEWSLETTER_LIST_SUCCESS';
export const NEWSLETTER_LIST_FAIL = 'NEWSLETTER_LIST_FAIL';

export const NEWSLETTER_DELETE_REQUEST = 'NEWSLETTER_DELETE_REQUEST';
export const NEWSLETTER_DELETE_SUCCESS = 'NEWSLETTER_DELETE_SUCCESS';
export const NEWSLETTER_DELETE_FAIL = 'NEWSLETTER_DELETE_FAIL';

export const NEWSLETTER_DELETE_ALL_REQUEST = 'NEWSLETTER_DELETE_ALL_REQUEST';
export const NEWSLETTER_DELETE_ALL_SUCCESS = 'NEWSLETTER_DELETE_ALL_SUCCESS';
export const NEWSLETTER_DELETE_ALL_FAIL = 'NEWSLETTER_DELETE_ALL_FAIL';

const API_URL = `${process.env.REACT_APP_API_URL}/newsletter`;
// Action Creators
export const createNewsletter = (email: string) => async (dispatch: any) => {
    try {
        dispatch({ type: NEWSLETTER_CREATE_REQUEST });

        const { data } = await axios.post(`${API_URL}`, { email });

        dispatch({
            type: NEWSLETTER_CREATE_SUCCESS,
            payload: data
        });
        message.success('E-Bülten kaydı başarıyla oluşturuldu');
    } catch (error: any) {
        dispatch({
            type: NEWSLETTER_CREATE_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
        throw error;
    }
};

export const listNewsletters = () => async (dispatch) => {
    try {
        dispatch({ type: NEWSLETTER_LIST_REQUEST });

        const response = await axios.get(`${API_URL}`);

        dispatch({
            type: NEWSLETTER_LIST_SUCCESS,
            payload: response.data
        });
    } catch (error: any) {
        dispatch({
            type: NEWSLETTER_LIST_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
    }
};

export const deleteNewsletter = (id) => async (dispatch) => {
    try {
        dispatch({ type: NEWSLETTER_DELETE_REQUEST });

        await axios.delete(`${API_URL}/${id}`);

        dispatch({
            type: NEWSLETTER_DELETE_SUCCESS,
            payload: id
        });
    } catch (error: any) {
        dispatch({
            type: NEWSLETTER_DELETE_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
    }
};

export const deleteAllNewsletters = () => async (dispatch) => {
    try {
        dispatch({ type: NEWSLETTER_DELETE_ALL_REQUEST });

        await axios.delete(`${API_URL}`);

        dispatch({
            type: NEWSLETTER_DELETE_ALL_SUCCESS
        });
    } catch (error: any) {
        dispatch({
            type: NEWSLETTER_DELETE_ALL_FAIL,
            payload: error.response?.data?.message || 'Bir hata oluştu'
        });
    }
}; 